<template>
  <div>
    <Head title="會員中心 - 訂單查詢" />
    <order-template title="會員中心">
      <template #header>訂單查詢</template>
      <template v-if="$page.props.orders.length == 0">
        沒有任何訂單紀錄
      </template>
      <template v-else>
        <div
          class="order"
          :key="order.order_no"
          v-for="order in $page.props.orders"
        >
          <div class="column w-72">
            <label>訂單號碼</label>
            {{ order.order_no }}
          </div>
          <div class="column w-24">
            <label>訂單日期</label>
            {{ formatDate(order.created_at) }}
          </div>
          <div class="column w-20">
            <label> 金額 </label>
            {{ order.total_price | commaFormat | priceFormat }}
          </div>
          <div class="column w-28">
            <label>訂單狀態</label>
            {{ statusString(order.status) }}
          </div>
          <div class="column">
            <Button label="查看訂單" @click="showOrder(order.order_no)" />
          </div>
        </div>
      </template>
    </order-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import OrderTemplate from "./Shared/OrderTemplate";
import Button from "primevue/button";

export default {
  layout: Layout,
  components: {
    OrderTemplate,
    Button,
  },
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  methods: {
    showOrder(no) {
      this.$inertia.visit(route("user.orders.order", no));
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      return (
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        date.getDate().toString().padStart(2, "0")
      );
    },
    statusString(statusCode) {
      return this.$page.props.status_strings[statusCode];
    },
  },
};
</script>

<style lang="postcss">
.order {
  @apply w-full px-2 py-8 mb-2 border border-fh-gray-border flex justify-between flex-wrap;
}

.order .column {
  @apply flex flex-col;
}

.order .column label {
  @apply text-xs;
}
</style>